import ResultHeader from "../../components/table/ResultHeader";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import ResultBody from "../../components/table/ResultBody";
import getSettingsItem, {getSettingsSelectItem} from "./SettingsItem";
import ResultTable from "../../components/table/ResultTable";
import {Select} from "antd";
import {getProjectionOptions, DEFAULT_PROJECTION, getProjectionLabel} from "../../helpers/ProjectionHelper";

export default function DefaultSettings({onValuesChange, values, defValues}) {
    return (
        <>
            <div id={'defaults-places-div'}>
                <ResultTable>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: 300}}>Variable</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'left', width: 115}}>User Preference</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'left', width: 115}}>System Default</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'left', width: 230}}>Description</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            getSettingsItem({
                                value: values?.max_submergence_ratio,
                                defaultValue: defValues?.max_submergence_ratio,
                                onChange: (value) => {onValuesChange('max_submergence_ratio', value)},
                                label: 'Max Submergence Ratio',
                                description: 'MSR-001, MSR-002',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.contraction_ratio,
                                defaultValue: defValues?.contraction_ratio,
                                onChange: (value) => {onValuesChange('contraction_ratio', value)},
                                label: 'Contraction Ratio',
                                description: 'T-CES-001',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.expansion_ratio,
                                defaultValue: defValues?.expansion_ratio,
                                onChange: (value) => {onValuesChange('expansion_ratio', value)},
                                label: 'Expansion Ratio',
                                description: 'T-CES-001',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.cont_coef_natural_xs,
                                defaultValue: defValues?.cont_coef_natural_xs,
                                onChange: (value) => {onValuesChange('cont_coef_natural_xs', value)},
                                label: 'Contraction Coeff for Natural XS',
                                description: 'CEC-002',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.exp_coef_natural_xs,
                                defaultValue: defValues?.exp_coef_natural_xs,
                                onChange: (value) => {onValuesChange('exp_coef_natural_xs', value)},
                                label: 'Expansion Coeff for Natural XS',
                                description: 'CEC-002',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.cont_coef_structure_xs,
                                defaultValue: defValues?.cont_coef_structure_xs,
                                onChange: (value) => {onValuesChange('cont_coef_structure_xs', value)},
                                label: 'Contraction Coeff for Structure XS',
                                description: 'CEC-002',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.exp_coef_structure_xs,
                                defaultValue: defValues?.exp_coef_structure_xs,
                                onChange: (value) => {onValuesChange('exp_coef_structure_xs', value)},
                                label: 'Expansion Coeff for Structure XS',
                                description: 'CEC-001',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.manningsn_channel_min,
                                defaultValue: defValues?.manningsn_channel_min,
                                onChange: (value) => {onValuesChange('manningsn_channel_min', value)},
                                label: 'Manning\'s n Channel Min',
                                description: 'RT 04',
                                min: 0.000,
                                max: 5.00
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.manningsn_channel_max,
                                defaultValue: defValues?.manningsn_channel_max,
                                onChange: (value) => {onValuesChange('manningsn_channel_max', value)},
                                label: 'Manning\'s n Channel Max',
                                description: 'RT 04',
                                min: 0.000,
                                max: 5.00
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.manningsn_overbank_min,
                                defaultValue: defValues?.manningsn_overbank_min,
                                onChange: (value) => {onValuesChange('manningsn_overbank_min', value)},
                                label: 'Manning\'s n Overbank Min',
                                description: 'RT 04',
                                min: 0.000,
                                max: 5.00
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.manningsn_overbank_max,
                                defaultValue: defValues?.manningsn_overbank_max,
                                onChange: (value) => {onValuesChange('manningsn_overbank_max', value)},
                                label: 'Manning\'s n Overbank Max',
                                description: 'RT 04',
                                min: 0.000,
                                max: 5.00
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.struc_assoc,
                                defaultValue: defValues?.struc_assoc,
                                onChange: (value) => {onValuesChange('struc_assoc', value)},
                                label: 'Associate Structure Proximity (ft)',
                                description: '',
                                min: 0.000
                            })
                        }
                        {
                            getSettingsSelectItem({
                                value: values?.spatial_projection || DEFAULT_PROJECTION,
                                defaultValue: getProjectionLabel(defValues?.spatial_projection || DEFAULT_PROJECTION),
                                onChange: (value) => {onValuesChange('spatial_projection', value)},
                                label: 'Spatial Projection',
                                description: 'Map Coordinate System',
                                options: getProjectionOptions().map(opt => (
                                    <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>
                                ))
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </div>
        </>
    )
}